











































































































































































































































































































































































































































































































import { Vue, Component, InjectReactive } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { inject } from 'inversify-props';
import { AgGridVue } from '@ag-grid-community/vue';
import {
  SelectionChangedEvent,
  GridReadyEvent,
  ValueGetterParams,
  ValueFormatterParams,
  ColDef,
} from '@ag-grid-community/core';
import { isArray, sortBy } from 'lodash';
import { plainToClass } from 'class-transformer';
import DateRangeFilter from '@/components/date-range-filter.vue';
import { IDateRangeConfig } from '@/interfaces/date-range-config.interface';
import Tooltip from '@/components/tooltip.vue';
import DataGridFilter from '@/components/data-grid-filter.vue';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import RouterService from '@/services/router.service';
import SettingsService from '@/services/crm/settings.service';
import SettingsModel from '@/models/crm/settings.model';
import ContentDialog from '@/components/content-dialog.vue';
import { DateHelper } from '@/utils/helpers/date-helper';
import ClientModel from '@/models/crm/client.model';
import AgGridWrapper from '@/components/ag-grid-wrapper.vue';
import { IGridCellEvent } from '@/interfaces/grid-cell-clicked.interface';
import { IGridConfig } from '@/interfaces/grid-config.interface';
import { GridHelper } from '@/utils/helpers/grid-helper';
import { IKeyValue } from '@/interfaces/key-value.interface';
import { IDialogConfig } from '@/interfaces/dialog-config.interface';
import ConversationService from '@/services/crm/conversation.service';
import HistoryTypeModel from '@/models/crm/history-type.model';
import AttendanceModel from '@/models/crm/attendance.model';
import ConversationDepartmentModel from '@/models/crm/conversation-department.model';
import UserModel from '@/models/user.model';
import ActivityService from '@/services/crm/activity.service';
import ConversationModel from '@/models/crm/conversation.model';
import { ClientTypeEnum } from '@/enums/client-type.enum';
import ContactModel from '@/models/crm/contact.model';
import ContactService from '@/services/crm/contact.service';
import ClientService from '@/services/crm/client.service';
import { ClientCnpjHelper } from '@/utils/helpers/client-cnpj-helper';
import CrmChatHistoryMessagesViewer from '../../components/crm/chat-history-messages-viewer.vue';
import CrmEvoTalksChatHistoryViewer from '../../components/crm/crm-evotalks-chat-history-viewer.vue';
import ConversationTemplateModel from '@/models/crm/conversation-template.model';
import CRMEvoTalksService from '@/services/crm/evotalks.service';
import EvoTalksConversaFilterModel from '@/models/crm/evotalks-conversa-filter.model';
import EvoTalksConversaResumoModel from '@/models/crm/evotalks-conversa-resumo.model';
import EvoTalksFilaModel from '@/models/crm/evotalks-fila.model';
import EvoTalksAgenteModel from '@/models/crm/evotalks-agente.model';

type DataGridFilterConfig = {
  client: string[] | null;
  prospect: number[] | null;
  periodType: PeriodTypeEnum;
  period: (Date | undefined)[];
  status: StatusEnum | null;
  department: ConversationDepartmentModel[] | null;
  attendant: AttendanceModel[] | null;
  originType: OriginTypeEnum[] | null;
  template: ConversationTemplateModel[] | null;
  historyType: HistoryTypeModel[] | null;
  protocolNumber: string | null;
  contact: ContactModel[] | null;
  classification: ClassificationEnum[] | null;
};

enum PeriodTypeEnum {
  OpenDate = 'OPEN_DATE',
  StartDate = 'START_DATE',
  ClosingDate = 'CLOSING_DATE',
}

enum StatusEnum {
  Open = 'OPEN',
  Closed = 'CLOSED',
}

enum ClassificationEnum {
  Mistake = 'MISTAKE',
  Justified = 'JUSTIFIED',
  None = 'NONE',
}

enum OriginTypeEnum {
  Active = 2,
  Receptive = 1,
  Transfer = 3,
}

enum NumberTypeEnum {
  Homologado = 1,
  GeoChat = 2,
}

enum IntegrationTypeEnum {
  WhatsApp360 = 'WHATSAPP_360',
  EvoTalks = 'EVOTALKS',
}

type EvoTalksFilterConfig = {
  periodType: PeriodTypeEnum;
  period: (Date | undefined)[];
  status: string | null;
  idFilaEvo: string | null;
  tipoCanal: string | null;
  idAtendenteGeo: number | null;
  numeroTelefone: string | null;
  protocolo: string | null;
  conteudo: string | null;
  nomeContato: string | null;
  tipoContato: string | null;
  apenasComProtocolo: boolean;
};

interface ISelectOption<T> {
  code: T;
  description: string;
}

function resolveQueueTypeBadgeColor(type: string | null | undefined): string {
  if (type === 'WAGS') return 'success';
  if (type === 'WAMD2') return 'info';
  return 'grey';
}

@Component({
  components: {
    DataGridFilter,
    DateRangeFilter,
    Tooltip,
    AgGridWrapper,
    AgGridVue,
    ContentDialog,
    CrmChatHistoryMessagesViewer,
    CrmEvoTalksChatHistoryViewer,
  },
})
export default class CrmOrders extends Vue {
  @inject(InjectionIdEnum.CrmClientService)
  private clientService!: ClientService;

  @inject(InjectionIdEnum.CrmSettingsService)
  private settingsService!: SettingsService;

  @inject(InjectionIdEnum.CrmContactService)
  private contactService!: ContactService;

  @inject(InjectionIdEnum.RouterService)
  private routerService!: RouterService;

  @inject(InjectionIdEnum.CrmActivityService)
  private activityService!: ActivityService;

  @inject(InjectionIdEnum.CrmConversationService)
  private conversationService!: ConversationService;

  @inject(InjectionIdEnum.CRMEvoTalksService)
  private evoTalksService!: CRMEvoTalksService;

  @InjectReactive('activeClient') readonly activeClient!: ClientModel;

  @InjectReactive('clientType') readonly clientType!: ClientTypeEnum;

  private settings!: SettingsModel;

  grid: GridReadyEvent | null = null;

  gridSettings: IGridConfig = {
    loading: false,
    defaultSort: [{ colId: 'dataUltimaMensagem', sort: 'desc' }],
    columnDefs: [
      GridHelper.getSelectionColDef(),
      ClientCnpjHelper.getOriginColDef(`${this.$t('crm.originCnpj')}`),
      {
        headerName: `${this.$t('crm.view.chatReport.grid.number')}`,
        colId: 'cellphone',
        field: 'numeroCanalVendas',
        minWidth: 140,
        maxWidth: 140,
        flex: 0.8,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.numberType')}`,
        colId: 'cellphone',
        field: 'tipoCanal',
        minWidth: 140,
        maxWidth: 140,
        flex: 0.8,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.openDate')}`,
        colId: 'openDate',
        field: 'dataInclusao',
        minWidth: 130,
        maxWidth: 130,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataInclusao;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params: ValueFormatterParams): string => {
          if (params.value && params.value !== 'Invalid Date') {
            return DateHelper.formatToLocale(params.value, 'dateTime');
          }
          return '';
        },
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.startDate')}`,
        colId: 'startDate',
        field: 'dataInicio',
        minWidth: 150,
        maxWidth: 150,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataInicio;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params: ValueFormatterParams): string => {
          if (params.value && params.value !== 'Invalid Date') {
            return DateHelper.formatToLocale(params.value, 'dateTime');
          }
          return '';
        },
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.closeDate')}`,
        colId: 'closeDate',
        field: 'dataFechamento',
        minWidth: 130,
        maxWidth: 130,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataFechamento;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params: ValueFormatterParams): string => {
          if (params.value && params.value !== 'Invalid Date') {
            return DateHelper.formatToLocale(params.value, 'dateTime');
          }
          return '';
        },
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.chats.grid.lastAttendance')}`,
        colId: 'lastAttendance',
        field: 'dataUltimaMensagem',
        minWidth: 130,
        maxWidth: 130,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataUltimaMensagem || params.data.dataInicio || params.data.dataInclusao;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params): string => DateHelper.formatToLocale(params.value, 'dateTime'),
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.originType')}`,
        colId: 'OriginType',
        field: 'origemConversa',
        minWidth: 120,
        maxWidth: 120,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.template')}`,
        colId: 'Template',
        field: 'templateConversa',
        minWidth: 210,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.cellPhone')}`,
        colId: 'cellphone',
        field: 'numeroWhatsapp',
        minWidth: 120,
        maxWidth: 120,
        flex: 0.8,
        sortable: false,
      },
      {
        headerName: `${this.$t('crm.view.chats.grid.contactName')}`,
        colId: 'contactName',
        field: 'contato.nome',
        minWidth: 150,
        flex: 0.8,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const isRowPinned = params.node && params.node.rowPinned;
          if (!isRowPinned) {
            return params.data?.contato?.nome || params.data.numeroWhatsapp;
          }
          return '';
        },
      },
      {
        headerName: `${this.$t('crm.view.chats.grid.protocol')}`,
        colId: 'protocol',
        field: 'protocolo',
        minWidth: 160,
        maxWidth: 160,
        cellClass: 'cell-grid-link',
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.chats.grid.attendant')}`,
        colId: 'attendant',
        field: 'atendente.nome',
        minWidth: 120,
        flex: 0.5,
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.chats.grid.department')}`,
        colId: 'department',
        field: 'departamento.nome',
        minWidth: 120,
        flex: 0.5,
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.chats.grid.historyType')}`,
        colId: 'historyType',
        field: 'tipoHistorico.nome',
        minWidth: 150,
        flex: 0.8,
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.chatReport.grid.classification')}`,
        colId: 'classification',
        field: 'engano',
        minWidth: 120,
        maxWidth: 160,
        sortable: false,
        valueGetter: (params: ValueGetterParams): string => {
          const isRowPinned = params.node && params.node.rowPinned;
          if (!isRowPinned) {
            if (params.data?.engano === 1) {
              return this.$t('crm.view.chatReport.filter.mistake').toString();
            }
            if (params.data?.outraJustificativaFechamento === 1) {
              return this.btnCloseNotSavingContact;
            }
            return this.$t('crm.view.chatReport.filter.noClassification').toString();
          }
          return '';
        },
      },
    ],
  };

  items: ConversationModel[] = [];

  itemsProspect: ConversationModel[] = [];

  selected: ConversationModel[] = [];

  // #region EvoTalks state

  activeIntegration: IntegrationTypeEnum = IntegrationTypeEnum.WhatsApp360;

  evoTalksItems: EvoTalksConversaResumoModel[] = [];

  evoTalksFilaOptions: EvoTalksFilaModel[] = [];

  evoTalksAgenteOptions: EvoTalksAgenteModel[] = [];

  evoTalksFiltersLoaded = false;

  evoTalksFilters: EvoTalksFilterConfig = {
    periodType: PeriodTypeEnum.OpenDate,
    period: [dayjs().startOf('month').toDate(), dayjs().toDate()],
    status: null,
    idFilaEvo: null,
    tipoCanal: null,
    idAtendenteGeo: null,
    numeroTelefone: null,
    protocolo: null,
    conteudo: null,
    nomeContato: null,
    tipoContato: null,
    apenasComProtocolo: false,
  };

  evoTalksColumnDefs = [
    ClientCnpjHelper.getOriginColDef(`${this.$t('crm.originCnpj')}`),
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.protocol')}`,
      colId: 'protocol',
      field: 'protocolo',
      cellClass: 'cell-grid-link',
      minWidth: 160,
      maxWidth: 160,
      sortable: true,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.status')}`,
      colId: 'status',
      field: 'status',
      minWidth: 100,
      maxWidth: 100,
      sortable: true,
      valueFormatter: (params: ValueFormatterParams): string => {
        if (params.value === 'ABERTA') return 'Aberto';
        if (params.value === 'FECHADA') return 'Fechado';
        return params.value || '';
      },
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.phoneNumber')}`,
      colId: 'phoneNumber',
      field: 'numeroTelefone',
      minWidth: 140,
      maxWidth: 140,
      sortable: false,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.contactName')}`,
      colId: 'contactName',
      field: 'nomeContato',
      minWidth: 180,
      sortable: true,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.startDate')}`,
      colId: 'startDate',
      field: 'dataInicio',
      minWidth: 150,
      maxWidth: 150,
      sortable: true,
      valueGetter: (params: ValueGetterParams): string => {
        const date = params.data?.dataInicio;
        return DateHelper.formatToIsoDateTimeString(date);
      },
      valueFormatter: (params: ValueFormatterParams): string => {
        if (params.value && params.value !== 'Invalid Date') {
          return DateHelper.formatToLocale(params.value, 'dateTime');
        }
        return '';
      },
      cellClass: 'dateISO',
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.closeDate')}`,
      colId: 'closeDate',
      field: 'dataFechamento',
      minWidth: 150,
      maxWidth: 150,
      sortable: true,
      valueGetter: (params: ValueGetterParams): string => {
        const date = params.data?.dataFechamento;
        return DateHelper.formatToIsoDateTimeString(date);
      },
      valueFormatter: (params: ValueFormatterParams): string => {
        if (params.value && params.value !== 'Invalid Date') {
          return DateHelper.formatToLocale(params.value, 'dateTime');
        }
        return '';
      },
      cellClass: 'dateISO',
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.attendant')}`,
      colId: 'attendant',
      field: 'atendente',
      minWidth: 150,
      sortable: true,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.queue')}`,
      colId: 'queue',
      field: 'fila',
      minWidth: 150,
      sortable: true,
    },
    {
      headerName: `${this.$t('crm.view.chatReport.evoTalksGrid.endReason')}`,
      colId: 'endReason',
      field: 'endReason',
      minWidth: 160,
      sortable: true,
    },
  ];

  // #endregion

  // #region filters

  predefinedPeriodRanges: IDateRangeConfig[] = this.getDateRanges();

  multipleFilterChanged = false;

  clientCnpjs: string[] = [];

  filters: DataGridFilterConfig = {
    client: null,
    prospect: null,
    periodType: PeriodTypeEnum.OpenDate,
    period: [dayjs().startOf('year').toDate(), dayjs().toDate()],
    status: null,
    department: null,
    attendant: null,
    originType: [OriginTypeEnum.Active, OriginTypeEnum.Receptive, OriginTypeEnum.Transfer],
    template: null,
    historyType: null,
    protocolNumber: null,
    contact: null,
    classification: null,
  };

  periodTypeOptions: ISelectOption<PeriodTypeEnum>[] = [];

  statusOptions: ISelectOption<StatusEnum>[] = [];

  classificationOptions: ISelectOption<ClassificationEnum>[] = [];

  btnCloseNotSavingContact = '';

  departmentOptions: ConversationDepartmentModel[] = [];

  contactOptions: ContactModel[] = [];

  attendantOptions: UserModel[] = [];

  originTypeOptions: ISelectOption<OriginTypeEnum>[] = [];

  templateOptions: ConversationTemplateModel[] = [];

  historyTypeOptions: HistoryTypeModel[] = [];

  numberTypeOptions: ISelectOption<NumberTypeEnum>[] = [];

  loadingChats = false;

  // #endregion

  dialogConfig: IKeyValue<IDialogConfig> = {
    history: {
      show: false,
      conversation: null,
    },
    prospectChats: {
      show: false,
    },
  };

  async mounted(): Promise<void> {
    const loader = this.$loading.show();
    try {
      this.settings = await this.settingsService.getSettings();
      await this.loadFilterOptions();
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      loader.hide();
    }

    if (this.isProspectType) {
      this.filters.prospect = [parseInt(this.getClientIdFromRoute(), 10)];
    } else {
      this.filters.client = await this.getClientCnpjs();
    }

    this.loadItems();
  }

  get isEvoTalksMode(): boolean {
    return this.activeIntegration === IntegrationTypeEnum.EvoTalks;
  }

  onIntegrationChange(): void {
    if (this.isEvoTalksMode) {
      this.loadEvoTalksFilterOptions();
      this.loadEvoTalksItems();
    } else {
      this.loadItems();
    }
  }

  onEvoTalksFilterChange(type: string): void {
    if (type === 'multiple' && !this.multipleFilterChanged) {
      return;
    }
    this.multipleFilterChanged = false;
    this.loadEvoTalksItems();
  }

  private async loadEvoTalksFilterOptions(): Promise<void> {
    if (this.evoTalksFiltersLoaded) return;
    try {
      const [filas, agentes] = await Promise.all([
        this.evoTalksService.getFilas(),
        this.evoTalksService.getAgentes(),
      ]);
      this.evoTalksFilaOptions = filas;
      this.evoTalksAgenteOptions = agentes;
      this.evoTalksFiltersLoaded = true;
    } catch (err) {
      this.$notify.error(`Erro ao carregar filtros EvoTalks: ${(err as Error)?.message || err}`);
    }
  }

  private async loadEvoTalksItems(): Promise<void> {
    this.gridSettings.loading = true;
    try {
      this.evoTalksFilters.period[0] = dayjs(this.evoTalksFilters.period[0]).startOf('day').toDate();
      this.evoTalksFilters.period[1] = dayjs(this.evoTalksFilters.period[1]).endOf('day').toDate();

      const filter = new EvoTalksConversaFilterModel();
      filter.tipoPeriodo = this.evoTalksFilters.periodType || null;
      filter.dataInicio = this.evoTalksFilters.period[0] || null;
      filter.dataFim = this.evoTalksFilters.period[1] || null;
      filter.status = this.evoTalksFilters.status || null;
      filter.idFilaEvo = this.evoTalksFilters.idFilaEvo || null;
      filter.tipoCanal = this.evoTalksFilters.tipoCanal || null;
      filter.idAtendenteGeo = this.evoTalksFilters.idAtendenteGeo || null;
      filter.numeroTelefone = this.evoTalksFilters.numeroTelefone || null;
      filter.protocolo = this.evoTalksFilters.protocolo || null;
      filter.nomeContato = this.evoTalksFilters.nomeContato || null;
      filter.tipoContato = this.evoTalksFilters.tipoContato || null;
      filter.apenasComProtocolo = this.evoTalksFilters.apenasComProtocolo || false;

      if (this.isProspectType) {
        filter.idProspect = parseInt(this.getClientIdFromRoute(), 10);
        const response = await this.evoTalksService.queryConversations(1, 999, filter);
        this.evoTalksItems = response.results;
      } else {
        const queryByCnpj = async (cnpj: string) => {
          const filterByCnpj = Object.assign(new EvoTalksConversaFilterModel(), filter, { cnpj });
          return (await this.evoTalksService.queryConversations(1, 999, filterByCnpj)).results;
        };
        this.evoTalksItems = await ClientCnpjHelper.loadFromCnpjs(await this.getClientCnpjs(), queryByCnpj);
      }
      this.updateOriginCnpjColumn();
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      this.gridSettings.loading = false;
    }
  }

  get evoTalksStatusOptions(): ISelectOption<string>[] {
    return [
      { code: 'ABERTA', description: this.$t('crm.view.chatReport.filter.open').toString() },
      { code: 'FECHADA', description: this.$t('crm.view.chatReport.filter.closed').toString() },
    ];
  }

  get evoTalksPeriodTypeOptions(): ISelectOption<PeriodTypeEnum>[] {
    return [
      { code: PeriodTypeEnum.OpenDate, description: this.$t('crm.view.chatReport.filter.openDate').toString() },
      { code: PeriodTypeEnum.ClosingDate, description: this.$t('crm.view.chatReport.filter.closingDate').toString() },
    ];
  }

  get evoTalksTipoContatoOptions(): ISelectOption<string>[] {
    return [
      { code: 'CLIENTE', description: this.$t('crm.view.chatReport.evoTalksFilter.tipoContatoCliente').toString() },
      { code: 'PROSPECT', description: this.$t('crm.view.chatReport.evoTalksFilter.tipoContatoProspect').toString() },
    ];
  }

  get evoTalksTipoCanalOptions(): ISelectOption<string>[] {
    return [
      { code: 'WAGS', description: this.$t('crm.view.chatReport.evoTalksFilter.tipoCanalHomologado').toString() },
      { code: 'WAMD2', description: this.$t('crm.view.chatReport.evoTalksFilter.tipoCanalGeochat').toString() },
    ];
  }

  queueTypeBadgeLabel(type: string | null | undefined): string {
    if (type === 'WAGS') return this.$t('crm.view.chatReport.evoTalksFilter.tipoCanalHomologado').toString();
    if (type === 'WAMD2') return this.$t('crm.view.chatReport.evoTalksFilter.tipoCanalGeochat').toString();
    return type || '';
  }

  queueTypeBadgeColor = resolveQueueTypeBadgeColor;

  get activeEvoTalksFilters(): number {
    let active = 0;
    if (this.evoTalksFilters.status) active += 1;
    if (this.evoTalksFilters.idFilaEvo) active += 1;
    if (this.evoTalksFilters.tipoCanal) active += 1;
    if (this.evoTalksFilters.idAtendenteGeo) active += 1;
    if (this.evoTalksFilters.numeroTelefone) active += 1;
    if (this.evoTalksFilters.protocolo) active += 1;
    if (this.evoTalksFilters.nomeContato) active += 1;
    if (this.evoTalksFilters.tipoContato) active += 1;
    if (this.evoTalksFilters.apenasComProtocolo) active += 1;
    const validDates = (this.evoTalksFilters.period || []).filter(
      (date) => date && !Number.isNaN(new Date(date).getTime()),
    );
    if (validDates.length > 0) active += 1;
    return active;
  }

  onFilterChange(type: string): void {
    if (type === 'multiple' && !this.multipleFilterChanged) {
      return;
    }

    this.multipleFilterChanged = false;
    this.loadItems();
  }

  async onCellClick(event: IGridCellEvent<ConversationModel>): Promise<void> {
    if (this.isEvoTalksMode) {
      if (event?.colDef?.colId === 'protocol' || event?.colDef?.colId === 'detailConversation') {
        const resumo = event.data as unknown as EvoTalksConversaResumoModel;
        if (resumo) {
          this.dialogConfig.history.show = true;
          this.dialogConfig.history.conversation = resumo;
        }
      }
      return;
    }

    if (!event.data || event?.colDef?.colId !== 'protocol') {
      return;
    }

    this.openHistoryConversationDialog(plainToClass(ConversationModel, event.data));
  }

  openHistoryConversationDialog(conversation: ConversationModel): void {
    if (!conversation) {
      return;
    }

    this.dialogConfig.history.show = true;
    this.dialogConfig.history.conversation = conversation;
  }

  onCloseHistoryDialogClose(): void {
    this.dialogConfig.history.show = false;
    this.dialogConfig.history.conversation = false;
  }

  onSelectionChanged(change: SelectionChangedEvent, selected: ConversationModel[]): void {
    this.selected = selected;
  }

  onExport(selected: ConversationModel[]): void {
    if (this.grid) {
      const activeColumnDefs: ColDef[] = this.isEvoTalksMode ? this.evoTalksColumnDefs : this.gridSettings.columnDefs;
      const onlySelected = !this.isEvoTalksMode && !!selected.length && this.items.length !== selected.length;
      const columnKeys = activeColumnDefs
        .filter((x) => !x.checkboxSelection)
        .filter((x) => x.colId !== ClientCnpjHelper.originColId || this.hasGroupedCnpjs)
        .map((x) => x.colId || x.field || '');

      this.grid.api.exportDataAsExcel({
        onlySelected,
        columnKeys,
        allColumns: true,
        author: 'IBtech',
        sheetName: 'Conversas',
        fileName: ConversationService.generateConversationReportExportFilename(new Date()),
      });
    }
  }

  get activeFilters(): number {
    let active = 0;
    const filtersToIgnore = ['periodType'];
    const filterKeys = Object.keys(this.filters);

    filterKeys.forEach((key) => {
      const filter = this.filters[key];
      switch (key) {
        default:
          if (!filtersToIgnore.includes(key) && filter && !(isArray(filter) && !filter.length)) {
            active += 1;
          }
      }
    });

    return active;
  }

  get viewTitle(): string {
    return this.$t('crm.view.chats.title', { clientType: this.$t(`crm.${this.clientType}`) }).toString();
  }

  get historyDialogTitle(): string {
    if (this.isEvoTalksMode) {
      const resumo = this.dialogConfig.history.conversation as unknown as EvoTalksConversaResumoModel;
      const protocol = resumo?.protocolo || resumo?.chatId || '';
      return this.$t('crm.view.chats.dialog.history.title', { protocol }).toString();
    }
    const protocol = (this.dialogConfig.history.conversation as ConversationModel)?.protocolo;
    return this.$t('crm.view.chats.dialog.history.title', { protocol }).toString();
  }

  get isProspectType(): boolean {
    return this.clientType === ClientTypeEnum.Prospect;
  }

  private async loadItems(): Promise<void> {
    this.gridSettings.loading = true;
    // this.items = await this.orderService.getOrders(this.getClientIdFromRoute());
    this.items = (
      await this.conversationService.queryConversationsPainel(
        1,
        999,
        this.filters as unknown,
      )
    ).results;
    this.updateOriginCnpjColumn();
    this.gridSettings.loading = false;
  }

  private async loadFilterOptions(): Promise<void> {
    this.periodTypeOptions = this.getPeriodTypes();
    this.statusOptions = this.getStatusOptions();
    this.originTypeOptions = this.getOriginTypeOptions();
    this.numberTypeOptions = this.getNumberTypeOptions();

    const tasks = [
      this.conversationService.getBtnCloseNotSavingContact().then((result) => {
        this.btnCloseNotSavingContact = result;
        this.classificationOptions = this.getClassificationOptions();
      }),
      this.getDepartments().then((result) => {
        this.departmentOptions = result;
      }),
      this.getAttendants().then((result) => {
        this.attendantOptions = result;
      }),
      this.getTemplates().then((result) => {
        this.templateOptions = result;
      }),
      this.getHistoryTypes().then((result) => {
        this.historyTypeOptions = result;
      }),
      this.getContacts().then((result) => {
        this.contactOptions = result;
      }),
    ];

    await Promise.all(tasks);
  }

  private async loadProspectChats(): Promise<void> {
    this.dialogConfig.prospectChats.show = true;
    this.loadingChats = true;
    this.filters.client = null;
    if (this.activeClient.prospectId) {
      this.filters.prospect = [this.activeClient.prospectId];
    }
    try {
      if (this.itemsProspect.length === 0) {
        this.itemsProspect = (
          await this.conversationService.queryConversationsPainel(
            1,
            999,
            this.filters as unknown,
            // orderBy,
          )
        ).results;
      }
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      this.loadingChats = false;
      if (this.isProspectType) {
        this.filters.prospect = [parseInt(this.getClientIdFromRoute(), 10)];
      } else {
        this.filters.client = this.clientCnpjs.length ? [...this.clientCnpjs] : [this.getClientIdFromRoute()];
      }
    }
  }

  private getPeriodTypes(): ISelectOption<PeriodTypeEnum>[] {
    return [
      {
        code: PeriodTypeEnum.OpenDate,
        description: this.$t('crm.view.chats.filter.openDate').toString(),
      },
      {
        code: PeriodTypeEnum.StartDate,
        description: this.$t('crm.view.chats.filter.startDate').toString(),
      },
      {
        code: PeriodTypeEnum.ClosingDate,
        description: this.$t('crm.view.chats.filter.closingDate').toString(),
      },
    ];
  }

  private getClassificationOptions(): ISelectOption<ClassificationEnum>[] {
    const res = [
      {
        code: ClassificationEnum.Mistake,
        description: this.$t('crm.view.chatReport.filter.mistake').toString(),
      },
    ];
    if (this.btnCloseNotSavingContact !== '') {
      res.push({
        code: ClassificationEnum.Justified,
        description: this.btnCloseNotSavingContact,
      });
    }
    res.push({
      code: ClassificationEnum.None,
      description: this.$t('crm.view.chatReport.filter.noClassification').toString(),
    });
    return res;
  }

  private getStatusOptions(): ISelectOption<StatusEnum>[] {
    return [
      {
        code: StatusEnum.Open,
        description: this.$t('crm.view.chats.filter.open').toString(),
      },
      {
        code: StatusEnum.Closed,
        description: this.$t('crm.view.chats.filter.closed').toString(),
      },
    ];
  }

  private getNumberTypeOptions(): ISelectOption<NumberTypeEnum>[] {
    return [
      {
        code: NumberTypeEnum.Homologado,
        description: this.$t('crm.view.chats.filter.homologated').toString(),
      },
      {
        code: NumberTypeEnum.GeoChat,
        description: this.$t('crm.view.chats.filter.geochat').toString(),
      },
    ];
  }

  private async getDepartments(): Promise<ConversationDepartmentModel[]> {
    return this.conversationService.getDepartments();
  }

  private async getAttendants(): Promise<UserModel[]> {
    return this.activityService.getAttendants();
  }

  private async getContacts(): Promise<ContactModel[]> {
    const cnpjs = this.isProspectType ? [this.getClientIdFromRoute()] : await this.getClientCnpjs();
    return ClientCnpjHelper.loadFromCnpjs(cnpjs, (cnpj) => this.contactService.getContacts(
      cnpj,
      this.clientType,
      this.settings.flagPermiteClientesSituacao99Crm360,
      cnpj !== cnpjs[0],
    ));
  }

  private getOriginTypeOptions(): ISelectOption<OriginTypeEnum>[] {
    return [
      {
        code: OriginTypeEnum.Active,
        description: this.$t('crm.view.chatReport.filter.activeConversation').toString(),
      },
      {
        code: OriginTypeEnum.Receptive,
        description: this.$t('crm.view.chatReport.filter.receptiveConversation').toString(),
      },
      {
        code: OriginTypeEnum.Transfer,
        description: this.$t('crm.view.chatReport.filter.transferConversation').toString(),
      },
    ];
  }

  private async getTemplates(): Promise<ConversationTemplateModel[]> {
    return sortBy(await this.conversationService.getTemplates(), 'waTemplateName');
  }

  private async getHistoryTypes(): Promise<HistoryTypeModel[]> {
    return sortBy(await this.activityService.getHistoryTypes(), 'nome');
  }

  private getDateRanges(): IDateRangeConfig[] {
    return [
      {
        name: `${this.$t('global.today')}`,
        ...DateHelper.getTodayPeriod(),
      },
      {
        name: `${this.$t('global.yesterday')}`,
        ...DateHelper.getYesterdayPeriod(),
      },
      {
        name: `${this.$t('global.currentMonth')}`,
        ...DateHelper.getCurrentMonthPeriod(),
      },
      {
        name: `${this.$t('global.lastMonth')}`,
        ...DateHelper.getLastMonthsPeriod(1),
      },
      {
        name: `${this.$t('global.lastThreeMonths')}`,
        ...DateHelper.getLastMonthsPeriod(3),
      },
      {
        name: `${this.$t('global.lastSixMonths')}`,
        ...DateHelper.getLastMonthsPeriod(6),
      },
      {
        name: `${this.$t('global.lastYear')}`,
        ...DateHelper.getLastYearsPeriod(1),
      },
      {
        name: `${this.$t('global.currentYear')}`,
        ...DateHelper.getCurrentYearPeriod(),
      },
    ];
  }

  private getClientIdFromRoute(): string {
    if (this.clientType === ClientTypeEnum.Prospect) {
      const currentRoute = this.routerService.route();
      return currentRoute.params && currentRoute.params.clientId;
    }
    return this.activeClient.cnpjCpf;
  }

  private async getClientCnpjs(): Promise<string[]> {
    const cnpjs = await this.clientService.getClientCnpjs(this.activeClient);
    this.clientCnpjs = cnpjs.length ? cnpjs : [this.getClientIdFromRoute()];
    return this.clientCnpjs;
  }

  get hasGroupedCnpjs(): boolean {
    return !this.isProspectType && this.clientCnpjs.length > 1;
  }

  private updateOriginCnpjColumn(): void {
    if (this.grid && this.grid.columnApi) {
      this.grid.columnApi.setColumnVisible(ClientCnpjHelper.originColId, this.hasGroupedCnpjs);
    }
  }
}
